"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@chakra-ui/react";
import { getTextColor } from "../../helpers";
const FieldTitle = ({ inputId, title, mandatory, disabled, textStyle, variant, }) => (_jsxs(Box, Object.assign({ as: "label", textStyle: textStyle || "body.mediumDemibold", color: getTextColor(disabled, variant), pb: "1" }, (inputId && { htmlFor: inputId }), { children: [title, mandatory ? (_jsx(Box, Object.assign({ as: "span", pl: "1", color: "semantic.text.highlight" }, { children: "*" }))) : null] })));
export default FieldTitle;
//# sourceMappingURL=FieldTitle.js.map